import VolumeMuteSvg from '@/assets/VolumeMuteSvg.svg';
import VolumeStatusSvg from '@/assets/VolumeStatusSvg.svg';
import { useAudioSettings } from '@/utils/providers/audioSettingsContext/useAudioSettings';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { FC } from 'react';
import { Button } from 'react-bootstrap';

const NarratorToggle: FC = () => {
  const { isNarratorEnabled, toggleNarrator } = useAudioSettings();
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslationWithPrefix('components.narrator');

  return (
    <Button
      className={`no-focus-styles ${isMobile ? 'p-1' : 'p-2'} bg-white border-2 border-black z-50`}
      onClick={toggleNarrator}
      title={isNarratorEnabled ? t('disable') : t('enable')}
    >
      <img
        alt={isNarratorEnabled ? 'narrator-enabled' : 'narrator-disabled'}
        src={isNarratorEnabled ? VolumeStatusSvg : VolumeMuteSvg}
        style={{
          height: isMobile ? '20px' : '24px',
          width: isMobile ? '20px' : '24px',
        }}
      />
    </Button>
  );
};

export default NarratorToggle;
